import { queryOptions, useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { PageTitle } from '@components/PageTitle';
import { proseContentClassName } from '@constants/proseContent.constant';
import { EQueryKeys } from '@enums/queryKeys.enum';
import { medicationCreatesService } from '@services/medicationCreates/service';

import { MessageCard } from '../@components/MessageCard';
import { TreatmentDetailsCard } from '../@components/TreatmentDetailsCard';

const medicationsQueryOptions = (id: string) =>
  queryOptions({
    refetchOnWindowFocus: false,
    queryKey: [EQueryKeys.NewMedicationDetails, id],
    queryFn: () => medicationCreatesService.getById(id),
    staleTime: 1000 * 60,
  });

export const Route = createFileRoute('/_layout/(private)/new-medications/$id')({
  component: NewMedicationDetails,
  loader: async ({ context, params }) => {
    await context.queryClient.ensureQueryData(
      medicationsQueryOptions(params.id),
    );
  },
});

function NewMedicationDetails() {
  const { queryClient } = Route.useRouteContext();
  const { id } = Route.useParams();

  const { data } = useQuery(medicationsQueryOptions(id));

  return (
    <div>
      <PageTitle hasBackButton title="Detalhes do medicamento" />
      {!!data && (
        <>
          <TreatmentDetailsCard
            id={data.medication.id}
            name={data.medication.title}
            page="/new-medications"
            priority={data.medication.priority}
            queryClient={queryClient}
            reward={data.medication.amount}
            showActions={false}
            status={data.medication.status}
          />

          {!!data.medication.collaborator && (
            <MessageCard messages={data.medication.messages} />
          )}

          <h6 className="mb-2 text-base text-gray-500">Conteúdo</h6>
          <div className="relative rounded-2xl bg-white p-6 shadow">
            <div
              className={proseContentClassName}
              dangerouslySetInnerHTML={{
                __html: data.medication.topics
                  .map(
                    topic =>
                      `
                    <h1 style="color:#211F54; font-weight:bold; font-size:24px;">
                      ${topic.title ? topic.title : ''}
                    </h1>
                    ${topic.content
                      .replaceAll(/href="\s*([^"]*?)\s*"/g, 'href="$1"')
                      // altura e largura de imagens
                      // .replaceAll(/\s*(width|height)="[^"]*"/g, '')
                      // medicamentos
                      .replaceAll(
                        /href="https:\/\/sistema\.oguiadeprescricao\.com\.br\/med\.php\?[^"]*?m=(\d+)[^"]*"/g,
                        'href="https://web.gpmed.app/medicamentos/$1"',
                      )
                      // temas
                      .replaceAll(
                        /href="https:\/\/sistema\.oguiadeprescricao\.com\.br\/topico\.php\?[^"]*?area=(\d+)[^"]*?tema=(\d+)[^"]*"/g,
                        'href="https://web.gpmed.app/temas/$1/topicos/$2"',
                      )}
                    </br>
                  `,
                  )
                  .join(''),
              }}
            />
          </div>
        </>
      )}
    </div>
  );
}
